module.exports = __webpack_public_path__ + "7068d56313792e54e8b151cb287b802c.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/colossal_clashes-320.webp.png
// module id = 225
// module chunks = 0